import React from "react";
import noSearch from "../../../assets/images/search1.svg";
import noSearchText from "../../../assets/images/search2.svg";

export const Search = () => {
  return (
    <div className="h-[82.5vh] flex flex-col justify-center items-center    bg-cover w-[100vw]">
      <div className="absolute top-[25%] ">
        <img
          src={noSearch}
          alt="no-search"
          className="w-[15rem]  border-[1px] border-white "
        />
        <img
          src={noSearchText}
          alt="no-search-text"
          className="w-[15rem] mt-10 "
        />
      </div>
    </div>
  );
};
